import { Link } from "react-router-dom";
import { Instagram, Mail, MapPin, Phone } from "lucide-react";

export default function Footer() {
    return (
        <footer data-testid="site-footer" className="relative mt-24 bg-arl-blue text-arl-cream">
            <div className="absolute inset-0 opacity-20 rhombus-bg pointer-events-none" />
            <div className="relative mx-auto max-w-7xl px-5 sm:px-8 py-14 grid grid-cols-1 md:grid-cols-4 gap-y-10 gap-x-6 md:gap-x-8">
                <div className="md:col-span-2">
                    <img
                        src="/images/logo-arlequin.webp"
                        alt="Arlequin Artisan Glacier"
                        className="h-16 w-auto mb-4 brightness-0 invert opacity-90"
                    />
                    <p className="font-display text-base sm:text-lg leading-snug max-w-md">
                        Glaces artisanales, sorbets plein fruit & douceurs faites maison à Bourg-en-Bresse.
                    </p>
                </div>

                <div>
                    <h4 className="text-xs uppercase tracking-[0.18em] text-arl-sun mb-4 font-semibold">
                        Visiter
                    </h4>
                    <ul className="space-y-2.5 text-sm">
                        <li>
                            <a
                                href="https://maps.google.com/?q=18+Rue+Gambetta+01000+Bourg-en-Bresse"
                                target="_blank"
                                rel="noreferrer"
                                className="flex items-start gap-2.5 hover:text-arl-sun transition"
                                data-testid="footer-address"
                            >
                                <MapPin size={16} className="mt-0.5 shrink-0" />
                                <span>
                                    18 Rue Gambetta
                                    <br />
                                    01000 Bourg-en-Bresse
                                </span>
                            </a>
                        </li>
                        <li>
                            <a
                                href="tel:0482849560"
                                className="flex items-center gap-2.5 hover:text-arl-sun transition"
                                data-testid="footer-phone"
                            >
                                <Phone size={16} />
                                04 82 84 95 60
                            </a>
                        </li>
                        <li>
                            <a
                                href="mailto:contact@arlequinglacier.fr"
                                className="flex items-center gap-2.5 hover:text-arl-sun transition"
                                data-testid="footer-email"
                            >
                                <Mail size={16} />
                                contact@arlequinglacier.fr
                            </a>
                        </li>
                        <li>
                            <a
                                href="https://instagram.com/arlequin_glacier"
                                target="_blank"
                                rel="noreferrer"
                                className="flex items-center gap-2.5 hover:text-arl-sun transition"
                                data-testid="footer-instagram"
                            >
                                <Instagram size={16} />
                                @arlequin_glacier
                            </a>
                        </li>
                    </ul>
                </div>

                <div>
                    <h4 className="text-xs uppercase tracking-[0.18em] text-arl-sun mb-4 font-semibold">
                        Horaires
                    </h4>
                    <ul className="text-sm divide-y divide-arl-cream/10" data-testid="footer-hours">
                        {[
                            { day: "Lundi", hours: "Fermé", closed: true },
                            { day: "Mardi", hours: "15:00 – 19:00" },
                            { day: "Mercredi", hours: "13:00 – 19:00" },
                            { day: "Jeudi", hours: "15:00 – 19:00" },
                            { day: "Vendredi", hours: "15:00 – 19:00" },
                            { day: "Samedi", hours: "13:00 – 19:00" },
                            { day: "Dimanche", hours: "Fermé", closed: true },
                        ].map((row) => (
                            <li
                                key={row.day}
                                className="flex items-center justify-between py-1.5"
                            >
                                <span className="text-arl-cream/75">{row.day}</span>
                                <span
                                    className={
                                        row.closed
                                            ? "text-arl-cream/40 italic"
                                            : "text-arl-cream"
                                    }
                                >
                                    {row.hours}
                                </span>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
            <div className="relative border-t border-arl-cream/15">
                <div className="mx-auto max-w-7xl px-5 sm:px-8 py-5 text-xs text-arl-cream/70 grid grid-cols-1 sm:grid-cols-3 items-center gap-3">
                    <span className="text-center sm:text-left" data-testid="footer-copyright">
                        © 2026 Arlequin Artisan Glacier · Bourg-en-Bresse
                    </span>
                    <nav
                        className="flex items-center justify-center gap-5"
                        data-testid="footer-legal-nav"
                    >
                        <Link
                            to="/mentions-legales"
                            className="hover:text-arl-sun transition"
                            data-testid="footer-link-legal"
                        >
                            Mentions légales
                        </Link>
                        <Link
                            to="/politique-confidentialite"
                            className="hover:text-arl-sun transition"
                            data-testid="footer-link-privacy"
                        >
                            Politique de confidentialité
                        </Link>
                    </nav>
                    <span className="text-center sm:text-right" data-testid="footer-credit">
                        Site conçu et réalisé par{" "}
                        <a
                            href="https://axeris-labs.fr"
                            target="_blank"
                            rel="noreferrer"
                            className="font-semibold text-arl-cream hover:text-arl-sun transition"
                        >
                            Axeris Labs
                        </a>
                    </span>
                </div>
            </div>
        </footer>
    );
}
